import { reducerWithInitialState } from 'typescript-fsa-reducers';
import type { State } from './calendar.types';
import {
  BatchHourModalMode,
  setBatchHourModalMode,
  setMemoryInboxVisibility,
  setSelectionProperty,
  storeFilter,
} from './calendar.types';

export const initialState: State = {
  fetchStatus: {
    fetchingSingle: true,
  },
  selection: {
    hourIds: [],
  },
  showMemoryInbox: false,
  filter: {},
  batchHourModalMode: BatchHourModalMode.Copy,
};

const reducer = reducerWithInitialState<State>(initialState)
  .caseWithAction(setSelectionProperty, (state, action) => {
    return {
      ...state,
      selection: {
        ...state.selection,
        [action.payload.key]: action.payload.value,
      },
    };
  })
  .caseWithAction(setMemoryInboxVisibility, (state, action) => {
    return {
      ...state,
      showMemoryInbox: action.payload,
    };
  })
  .caseWithAction(storeFilter, (state, action) => {
    return {
      ...state,
      filter: {
        ...state.filter,
        ...action.payload,
      },
    };
  })
  .case(setBatchHourModalMode, (state, mode) => ({
    ...state,
    batchHourModalMode: mode,
  }));

export default reducer;
